




























import { Component, Vue, Emit } from 'vue-property-decorator'
import { UpdateDeliveryAddress } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import constant from '@/utils/constant'
import pcaData from '@/assets/pca.json'

@Component({
  components: { VImageUpload }
})
export default class UpdateDeliveryInfoDialog extends Vue {
  private show = false
  private constant = constant
  private orderInfo: any // 打开弹窗时传过来的订单信息
  private formData: any = {
    // 变量需要换下
    deliveryName: undefined,
    deliveryMobilePhone: undefined,
    deliveryAddress: undefined,
    province: undefined,
    city: undefined,
    district: undefined,
    address: undefined
  }

  private requiredRule = {
    required: true,
    message: '不能为空',
    trigger: 'blur'
  }
  // element 表单校验
  // 变量名一致
  private rules = {
    deliveryName: [this.requiredRule],
    deliveryMobilePhone: [this.requiredRule],
    deliveryAddress: [this.requiredRule],
    province: [this.requiredRule],
    city: [this.requiredRule],
    district: [this.requiredRule]
  }

  @Emit('close')
  private close() {
    this.show = false
    ;(this.$refs.form as ElForm).resetFields()
    this.formData = {
      // 变量需要换下
      deliveryName: undefined,
      deliveryMobilePhone: undefined,
      deliveryAddress: undefined,
      province: undefined,
      city: undefined,
      district: undefined,
      address: undefined
    }
  }

  private pca = pcaData

  // 获取省数据
  private get provinceList() {
    return this.pca
  }
  // 获取市数据
  private get cityList() {
    if (!this.formData.province) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.formData.province)
    if (t.length <= 0) {
      return []
    }
    this.formData.provinceCode = t[0].code
    return t[0].children
  }
  // 获取区数据
  private get districtList() {
    if (!this.formData.province || !this.formData.city) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.formData.province)
    if (t.length <= 0) {
      return []
    }
    const t2 = t[0].children.filter((e: any) => e.name == this.formData.city)
    if (t2.length == 0) {
      return []
    }
    this.formData.cityCode = t2[0].code
    return t2[0].children
  }

  private provinceChange() {
    this.formData.city = undefined
    this.formData.cityCode = undefined
    this.formData.district = undefined
    this.formData.districtCode = undefined
  }

  private cityChange() {
    this.formData.district = undefined
    this.formData.districtCode = undefined
  }

  private districtChange() {
    if (this.districtList.length > 0) {
      const t3 = this.districtList.filter(
        (e) => e.name == this.formData.district
      )
      this.formData.districtCode = t3[0].code
    }
  }

  public async open(data: any | null = {}) {
    this.show = true
    // 打开弹窗时传过来的订单信息
    this.formData = { ...this.formData,...data }
  }

  // 保存按钮
  public async save() {
    this.formData.deliveryAddress =
      this.formData.province +
      this.formData.city +
      this.formData.district +
      this.formData.address
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      UpdateDeliveryAddress(this.formData).then((res) => {
        if (res) {
          this.$message.success('修改成功')
          this.$emit('success')
          this.close()
        }
      })
    })
  }
}
